import React from "react";
import { ReelMetadata } from "../../types";

interface AuroraHeaderProps {
  data: ReelMetadata;
  opacity: number;
  scale: number;
  translateY: number;
}

export const AuroraHeader: React.FC<AuroraHeaderProps> = ({
  data,
  opacity,
  scale,
  translateY,
}) => {
  return (
    <div
      style={{
        width: "100%",
        padding: "20px 28px",
        background: "rgba(13,31,26,0.88)",
        borderLeft: "3px solid #50fa7b",
        borderTop: "1px solid rgba(80,250,123,0.2)",
        borderRight: "1px solid rgba(189,147,249,0.2)",
        borderBottom: "1px solid rgba(189,147,249,0.2)",
        borderRadius: "0 8px 8px 0",
        boxShadow:
          "0 0 30px rgba(80,250,123,0.1), inset 0 0 20px rgba(13,31,26,0.6)",
        opacity,
        transform: `scale(${scale}) translateY(${translateY}px)`,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {/* Label */}
      <div
        style={{
          fontFamily: "'DM Sans', sans-serif",
          fontWeight: 500,
          fontSize: "11px",
          color: "#50fa7b",
          letterSpacing: "4px",
          textTransform: "uppercase",
          textShadow: "0 0 8px rgba(80,250,123,0.5)",
        }}
      >
        NATURE INTELLIGENCE
      </div>

      {/* Headline */}
      <h2
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "28px",
          fontWeight: 600,
          fontStyle: "italic",
          lineHeight: 1.3,
          color: "#e8fff5",
          margin: 0,
          textShadow: "0 0 20px rgba(80,250,123,0.08)",
        }}
      >
        {data.headline}
      </h2>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
